var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEckoDex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 840 840",
    width: 840,
    height: 840,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 { fill: #fff; }\r\n      .cls-2 { fill: #894aff; }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 427.724,
    cy: 427.525,
    r: 388.2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-275.176,-41.875)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "948.1,297.3 702.9,366.5 457.7,297.3 457.7,374.5 702.9,443.6 948.1,374.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "486.4,285.2 623.3,323.8 702.9,301.4 782.6,323.8 919.4,285.2 702.9,224.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "457.7,394.7 457.7,586.6 543.3,631.3 543.3,418.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "948.1,394.7 948.1,586.6 862.6,631.3 862.6,418.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "660.2,692.3 702.9,714.6 745.7,692.3 745.7,451.8 702.9,463.8 660.2,451.8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEckoDex);
export default __webpack_public_path__ + "static/media/eckoDEX.cfe75c9edba11065a2477dd088c19790.svg";
export { ForwardRef as ReactComponent };